import React, { useEffect, useState } from "react";
import prod from "../assets/prod.jpg";
import { MdArrowForwardIos } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa6";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { SlArrowUp } from "react-icons/sl";
import { SlArrowDown } from "react-icons/sl";
// import { GrDocumentPdf } from "react-icons/gr";
// import { MdKeyboardArrowRight } from "react-icons/md";
import { FaPlay } from "react-icons/fa";
import midex3 from "../assets/midex3.jpg"
import midex1 from "../assets/midex1.jpg"
import midex2 from "../assets/midex2.jpg"
import midex from "../assets/midex.mp4"
import { IoMdClose } from "react-icons/io";
import { FaArrowLeftLong } from "react-icons/fa6";
import Footer from "./Footer";
import { Link, useLocation } from "react-router-dom";
import Navigation from "./Navigation";


const FoamM = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isAddressableOpen, setIsAddressableOpen] = useState(false);
    const [isOpen1, setIsOpen1] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);
    const [showVideo, setShowVideo] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const location = useLocation();
    const currentPath = location.pathname;

    useEffect(() => {
        if (["/address", "/n3060", "/n765", "/smoke", "/other", "/flame"].includes(currentPath)) {
            setIsOpen(true);
        }

        if (["/address", "/n3060", "/n765"].includes(currentPath)) {
            setIsAddressableOpen(true);
        }

        if (["/nn100"].includes(currentPath)) {
            setIsOpen1(true);
        }

        if (["/foam", "/foamm"].includes(currentPath)) {
            setIsOpen2(true);
        }
    }, [currentPath]);

    return (
        <>
            <div className='sticky top-0 z-50 w-full bg-white shadow-md'>
                <Navigation />
            </div>
            <div className="relative overflow-hidden">
                <img src={prod} alt="Product" className={`w-full h-auto object-cover transition-transform duration-1000 ${isVisible ? 'scale-100' : 'scale-110'}`} />

                <div className="absolute inset-0 flex items-center justify-start px-4 xl:px-20 bg-black/40">
                    <h1 className={`uppercase text-xl md:text-2xl lg:text-5xl text-white transform transition-all duration-700 ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-10 opacity-0'}`}>
                        Products
                    </h1>
                </div>
            </div>

            <div className="w-full px-4 xl:px-20 py-3 xl:py-5 overflow-hidden">
                <div className={`flex flex-wrap items-center gap-2 text-md md:text-lg transform transition-all duration-700 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`}>
                    <Link to="/" className="uppercase text-green-700 hover:underline transition-colors duration-300">
                        Home
                    </Link>
                    <MdArrowForwardIos className="text-gray-600 text-xs mt-0.5" />
                    <Link to="/products" className="uppercase text-md md:text-lg text-green-700 hover:underline">
                        Products
                    </Link>
                    <MdArrowForwardIos className="text-gray-600 text-xs mt-0.5" />
                    <p className="text-md md:text-lg text-gray-800">
                        MIDEX III
                    </p>
                </div>
            </div>

            <div className="px-2 xl:px-20 py-4 xl:py-6">
                <div className="flex flex-col-reverse lg:flex-row gap-8 items-start justify-start">

                    <div className="w-full lg:w-auto">
                        <div className="py-2">
                            <Link to="/products">
                                <div className="group flex justify-between items-center bg-gray-200 px-4 py-4 w-full lg:w-72 shadow-sm">
                                    <h1 className="text-xl text-gray-900 uppercase group-hover:text-green-600 transition-colors duration-300 flex-1 pr-3">
                                        Products
                                    </h1>
                                    <span className="bg-green-600 text-white w-6 h-6 flex items-center justify-center text-sm flex-shrink-0">
                                        <FaArrowRight />
                                    </span>
                                </div>
                            </Link>
                        </div>

                        <div className="py-2">
                            <div className="bg-gray-200 px-4 py-4 w-full lg:w-72 shadow-sm">
                                <div className="group flex justify-between items-center cursor-pointer" onClick={() => setIsOpen(!isOpen)}>
                                    <h1 className="text-xl text-gray-800 group-hover:text-green-600 transition-colors duration-300 flex-1 pr-3">
                                        Fire Alarm Systems
                                    </h1>
                                    {isOpen ? (
                                        <IoIosArrowUp className="text-green-600 w-6 h-6" />
                                    ) : (
                                        <IoIosArrowDown className="text-green-600 w-6 h-6" />
                                    )}
                                </div>

                                {isOpen && (
                                    <div className="mt-4 bg-white px-4 py-3">
                                        <div className="space-y-2">
                                            <div className="flex justify-between items-center py-1 border-b border-gray-300 cursor-pointer" onClick={() => setIsAddressableOpen(!isAddressableOpen)}>
                                                <h1 className="text-lg font-semibold text-gray-800 mb-2 mt-1">
                                                    Addressable Systems
                                                </h1>
                                                {isAddressableOpen ? (
                                                    <SlArrowUp className="text-gray-500 w-4 h-4" />
                                                ) : (
                                                    <SlArrowDown className="text-gray-500 w-4 h-4" />
                                                )}
                                            </div>
                                            {isAddressableOpen && (
                                                <div>
                                                    <Link to="/address">
                                                        <h2 className={`text-md mt-4 mb-3 pl-3 ${currentPath === "/address" ? "text-green-600" : "text-gray-600 hover:text-green-600"}`}>Addressable Systems TOP</h2>
                                                    </Link>

                                                    <Link to="/n3060">
                                                        <h2 className={`text-md mb-3 pl-3 ${currentPath === "/n3060" ? "text-green-600" : "text-gray-600 hover:text-green-600"}`}>N3060
                                                        </h2>
                                                    </Link>
                                                    <Link to="/n765">
                                                        <h2 className={`text-md mb-3 pl-3 ${currentPath === "/n765" ? "text-green-600" : "text-gray-600 hover:text-green-600"}`}>N765
                                                        </h2>
                                                    </Link>
                                                    <div className="border-b border-gray-300"></div>
                                                </div>
                                            )}

                                            <Link to="/smoke">
                                                <div className="py-1 border-b border-gray-300">
                                                    <h1 className={`text-lg font-semibold mt-1 mb-2 ${currentPath === "/smoke" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                        Aspirating Smoke Detector (Protecview)</h1>
                                                </div>
                                            </Link>
                                            <Link to="/other">
                                                <div className="py-1">
                                                    <h1 className={`text-lg font-semibold mt-1 ${currentPath === "/other" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                        Common Devices</h1>
                                                </div>
                                            </Link>
                                            <Link to="/flame">
                                                <div className="py-1"><h1 className={`text-lg font-semibold mt-1 ${currentPath === "/flame" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                    IR3 Flame Detectors
                                                </h1>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="py-2">
                            <div className="bg-gray-200 px-4 py-4 w-full lg:w-72 shadow-sm">
                                <div className="group flex justify-between items-center cursor-pointer" onClick={() => setIsOpen1(!isOpen1)}>
                                    <div className="text-xl text-gray-800 group-hover:text-green-600 transition-colors duration-300 flex-1 pr-3">
                                        Nitrogen Gas Fire Suppression Systems
                                    </div>
                                    {isOpen1 ? (
                                        <IoIosArrowUp className="text-green-600 w-6 h-6" />
                                    ) : (
                                        <IoIosArrowDown className="text-green-600 w-6 h-6" />
                                    )}
                                </div>

                                {isOpen1 && (
                                    <div className="mt-4 bg-white px-4 py-4">
                                        <div className="space-y-2">
                                            <Link to="/nn100">
                                                <div className="border-b border-gray-300 pb-3">
                                                    <h2 className={`text-lg font-semibold ${currentPath === "/nn100" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                        Engineered Type (NN100)
                                                    </h2>
                                                </div>
                                            </Link>
                                            <Link to="/nn100">
                                                <div className="pb-1 mt-1">
                                                    <h2 className="text-lg font-semibold text-gray-800 hover:text-green-600 mt-2">Package Type</h2>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="py-2">
                            <div className="bg-gray-200 px-4 py-4 w-full lg:w-72 shadow-sm">
                                <div className="group flex justify-between items-center cursor-pointer" onClick={() => setIsOpen2(!isOpen2)}>
                                    <h1 className="text-xl text-gray-800 group-hover:text-green-600 transition-colors duration-300 flex-1 pr-3">
                                        Foam Extinguishing Systems
                                    </h1>
                                    {isOpen2 ? (
                                        <IoIosArrowUp className="text-green-600 w-6 h-6" />
                                    ) : (
                                        <IoIosArrowDown className="text-green-600 w-6 h-6" />
                                    )}
                                </div>

                                {isOpen2 && (
                                    <div className="mt-4 bg-white px-2 xl:px-4 py-2 xl:py-4">
                                        <div className="space-y-2">
                                            <Link to="/foam">
                                                <div className="border-b border-gray-300 pb-2">
                                                    <h2 className={`text-lg font-semibold mb-1 ${currentPath === "/foam" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                        High Expansion Foam (Perf-EX)
                                                    </h2>
                                                </div>
                                            </Link>
                                            <Link to="/foamm">
                                                <div className="pb-1 mt-2">
                                                    <h2 className={`text-lg font-semibold  mt-2 ${currentPath === "/foamm" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                        Package Type (MIDEX III)
                                                    </h2>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="py-2">
                            <Link to="/video">
                                <div className="group flex justify-between items-center bg-gray-200 px-4 py-4 w-full lg:w-72 shadow-sm">
                                    <h1 className={`text-xl flex-1 pr-3 transition-colors duration-300 ${currentPath === "/video" ? "text-green-600" : "text-gray-800 group-hover:text-green-600"}`}>
                                        Product Videos
                                    </h1>
                                    <span className="bg-green-600 text-white w-6 h-6 flex items-center justify-center text-sm flex-shrink-0">
                                        <FaArrowRight />
                                    </span>
                                </div>
                            </Link>
                        </div>
                    </div>

                    {/* MIDEX III Systems */}
                    <div className="px-2 xl:px-4">

                        <div className="block md:hidden w-fit mb-6">
                            <div className="flex items-center gap-3 bg-gray-200 text-gray-700 text-sm font-medium px-6 py-2 shadow-sm">
                                <FaArrowLeftLong className="w-3 h-3" />
                                <Link to="/products" className="hover:underline">
                                    Back to PRODUCTS
                                </Link>
                            </div>
                        </div>

                        <div className="flex flex-col items-start w-full">
                            <h1 className="text-2xl xl:text-4xl font-semibold">MIDEX III</h1>
                            <div className="border-t-4 border-green-700 mt-4 w-full max-w-6xl" />
                        </div>

                        <div className="flex flex-col md:flex-row items-start w-full gap-8 mt-4">
                            <div className="w-full md:w-[300px] flex-shrink-0 mt-5">
                                <img src={midex1} alt="Protecview" className="w-full h-full object-cover" />
                            </div>

                            <div className="flex-1">
                                <div className="flex items-start gap-2">
                                    <div className="w-1 h-6 bg-green-700 mt-6 flex-shrink-0" />
                                    <h1 className="text-xl md:text-2xl font-semibold text-gray-800 mt-5">
                                        The MIDEX III is a package type low to medium expansion foam fire extinguishing system.
                                    </h1>
                                </div>

                                <p className="text-gray-700 text-justify text-md mt-4 leading-relaxed">
                                    The MIDEX III can quickly and effectively extinguish a fire by switching between medium-expansion foam that has strong fire extinguishing ability and low-expansion foam that can radiate far.
                                </p>
                            </div>
                        </div>

                        <div className="pt-10">
                            <h1 className="text-2xl xl:text-4xl font-semibold text-gray-800">Introduction Video</h1>

                            <div className="flex w-20 h-1 mt-4">
                                <div className="w-1/2 bg-green-700" />
                                <div className="w-1/2 bg-gray-400" />
                            </div>

                            <div className="mt-10 bg-gray-300 p-10 relative">
                                {showVideo ? (
                                    <div className="relative w-full">
                                        {/* Video */}
                                        <video
                                            src={midex}
                                            controls
                                            autoPlay
                                            className="w-full h-auto object-contain"
                                        />

                                        <button onClick={() => setShowVideo(false)} className="absolute top-2 right-2 z-10 bg-black bg-opacity-70 p-1.5 rounded-full hover:bg-opacity-90 transition">
                                            <IoMdClose className="text-white text-2xl" />
                                        </button>
                                    </div>
                                ) : (
                                    <div className="relative w-full h-auto cursor-pointer" onClick={() => setShowVideo(true)}>
                                        <img src={midex3} alt="Play N3062 video" className="w-full h-auto object-contain" />
                                        <div className="absolute inset-0 flex items-center justify-center">
                                            <div className="bg-black bg-opacity-60 px-4 py-3 rounded-md">
                                                <FaPlay className="text-white text-xl" />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="pt-10">
                            <h1 className="text-2xl xl:text-4xl font-semibold text-gray-800">Product Data Sheets</h1>

                            <div className="flex w-20 h-1 mt-4">
                                <div className="w-1/2 bg-green-700" />
                                <div className="w-1/2 bg-gray-400" />
                            </div>

                            <div className="flex flex-col items-start w-full mt-6">
                                <h1 className="text-2xl xl:text-4xl font-semibold text-green-700">
                                    Low to Medium Expansion Foam Extinguishing System
                                </h1>
                                <div className="border-t-4 border-gray-400 mt-4 w-full max-w-6xl" />

                                <div className="w-full md:w-[300px] flex-shrink-0 mt-6 mb-6">
                                    <img src={midex2} alt="Address" className="w-full h-auto object-cover" />

                                    <div className="p-4 flex flex-col gap-3">
                                        <h1 className="text-lg font-bold">
                                            Low to Medium Expansion Foam Extinguishing System
                                        </h1>

                                        {/* <div className="flex items-center gap-1 flex-wrap">
                                            <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                            <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                MRFJ001
                                            </h2>
                                            <GrDocumentPdf className="w-6 h-6 text-red-600 cursor-pointer ml-3" />
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <Footer />
            </div>
        </>
    );
};

export default FoamM;